/**
 * Whether anything to do with paying is offered in this build.
 *
 * Dev and local only for now: a purchase there is simulated, and finishes at the
 * point a real one would hand over to the store. Production has no routes for it
 * on the server (`internal/billing.EnabledFor`) and shows none of it here, so
 * this must stay false until real billing exists - and until then the two gates
 * are independent, so neither can open the other by accident.
 *
 * Same shape as `campaign/release.ts`. A parameter for the test; the app calls
 * it bare.
 */
const BILLING_IN_PRODUCTION = false;

export function billingVisible(appEnv: string | undefined = import.meta.env.VITE_APP_ENV): boolean {
  return BILLING_IN_PRODUCTION || appEnv !== "prod";
}
